import State from '../core/State';
import { SalesByCategoryData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSalesByCategory = () =>
  produce((draft: Draft<State>) => {
    draft.salesByCategory.fetching = draft.salesByCategory.fetching + 1;
  });

export const setSalesByCategory = (salesByCategoryData: SalesByCategoryData) =>
  produce((draft: Draft<State>) => {
    draft.salesByCategory.data = salesByCategoryData;
  });

export const finishFetchingSalesByCategory = () =>
  produce((draft: Draft<State>) => {
    draft.salesByCategory.fetching = draft.salesByCategory.fetching - 1;
  });

export const disposeSalesByCategory = () =>
  produce((draft: Draft<State>) => {
    draft.salesByCategory.data = initialState.salesByCategory.data;
    draft.salesByCategory.fetching = initialState.salesByCategory.fetching;
  });
